var _excluded = ["onClick", "children", "isSelected", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useListItem } from '@floating-ui/react';
import { Tooltip } from '../../../../components/dataDisplay';
import { Box, ConditionalWrapper } from '../../../../components/internal';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { useBaseMenuContext } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var Item = _ref => {
  var {
    onClick,
    children,
    isSelected,
    disabled
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    getItemProps,
    activeIndex
  } = useBaseMenuContext();
  var {
    ref,
    index
  } = useListItem();
  var styles = useMultiStyleConfig('BaseMenu', {});
  var disabledMessage = disabled === null || disabled === void 0 ? void 0 : disabled.message;
  var shouldShowTooltip = Boolean((disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled) && disabledMessage);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: Boolean(shouldShowTooltip),
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
      label: disabledMessage,
      children: children
    }),
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      "data-component": "BaseMenu.Item",
      role: "menuitem",
      as: "button" // ts-ignore is used due to `type` issues with `<Box/>`.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ,
      type: "button",
      "data-testid": "base-menu-item-".concat(index),
      __css: styles['item']
    }, getItemProps(_objectSpread({
      ref,
      tabIndex: activeIndex === index ? 0 : -1,
      onClick,
      'aria-selected': isSelected
    }, props))), {}, {
      children: children
    }))
  });
};
Item.displayName = 'BaseMenu.Item';
//# sourceMappingURL=Item.js.map